import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    '& > *': {
      margin: theme.spacing(2)
    },
  },
  section: {
    marginTop: theme.spacing(3),
  },
  schedule_root: {
      width: '100%',
  },
  schedule_details: {
      display: 'block',
  },
  schedule_header: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0,
  },
  schedule_subHeader: {
      marginBottom: theme.spacing(1),
  },
  schedule_sectionContainer: {
      width: '100%',
      // minHeight: 150,
      border: `solid #eee 1px`,
      borderRadius: '3px',
      padding: '20px',
      marginBottom: theme.spacing(3),
  },
  tab_root: {
    borderBottom: `1px solid #eee`,
    marginBottom: theme.spacing(4),
  },
  accordionLessonSchedule: {
    minHeight: "500px",
    width: '100%',
    border: `solid #eee 1px`,
    borderRadius: '3px',
    padding: '20px',
    marginBottom: theme.spacing(3),

  },
  table_headerText: {
      fontSize: '18px',
  },
  table_row: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  table_expandCaret: {
      width: '5%',
  },
  text: {
    fontSize: '16px',
    marginLeft: '5%',
  },
  labelIcon: {
    marginRight: theme.spacing(1),
    display: 'flex',
    padding: '0px',
  },
  dfb: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    maxHeight: 550,
    padding: '10px'
},
dfe: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: 0,
    padding: 0
},
userSearchResultsTable: {
  width: '100%',
  cursor: 'pointer',
  paddingLeft: 0,
  paddingRight: 0,
  display: 'table'
},
userSearchSelectedRow: {
  backgroundColor: '#3B4B95',
  '& > *': { color: 'white' }
},
userActionButtons: {
    padding: '10px',
    marginTop: theme.spacing(2)
},
errMsg: {
    fontSize: '1rem',
    color: 'red',
    marginTop: theme.spacing(2)
},
successMsg: {
    width: '15rem',
    color: 'green'
},
nudgedSelectlist: {
  marginLeft: theme.spacing(-2)
},
loaderContainer: {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
},
});

export const getScheduleTableStyles = (theme: Theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
});
